export enum ESituationPersonalCheck {
  WAIT = 1,
  APPROVED = 4,
  REPROVED = 5,
  CANCELED = 6,
  IN_PROGRESS_REGISTER_MANAGEMENT = 7,
  SENDING_REGISTRATION_REGISTER_MANAGEMENT = 8,
  PENDING = 9,
  AWAITING_CONSENT = 10,
}
